{
  "INBOX_MGMT": {
    "HEADER": "Boîtes de réception",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "Il n'y a aucune boîte de réception associée à ce compte."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choisir un canal",
        "BODY": "Choisissez le fournisseur que vous souhaitez intégrer avec Chatwoot."
      },
      "INBOX": {
        "TITLE": "Créer une boîte de réception",
        "BODY": "Authentifiez votre compte et créez une boîte de réception."
      },
      "AGENT": {
        "TITLE": "Ajouter des agents",
        "BODY": "Ajouter des agents à la boîte de réception créée."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Vous êtes paré !"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nom de la boîte de réception",
        "PLACEHOLDER": "Entrez le nom de votre boîte de réception (ex: Acme Inc)",
        "ERROR": "Veuillez entrer un nom de compte valide"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nom du site web",
        "PLACEHOLDER": "Entrez le nom de votre boîte de réception (ex: Acme Inc)"
      },
      "FB": {
        "HELP": "PS : En vous connectant, nous avons seulement accès aux messages de votre page. Vos messages privés ne peuvent jamais être consultés par Chatwoot.",
        "CHOOSE_PAGE": "Choisir la page",
        "CHOOSE_PLACEHOLDER": "Sélectionnez une page dans la liste",
        "INBOX_NAME": "Nom de la boîte de réception",
        "ADD_NAME": "Ajouter un nom pour votre boîte de réception",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Choisir une valeur",
        "CREATE_INBOX": "Créer une boîte de réception"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continuer avec Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connectez votre profil Instagram",
        "HELP": "Pour ajouter votre profil Instagram en tant que canal, vous devez authentifier votre profil Instagram en cliquant sur 'Continuer avec Instagram' ",
        "ERROR_MESSAGE": "Une erreur est survenue lors de la connexion à Instagram, veuillez réessayer",
        "ERROR_AUTH": "Une erreur est survenue lors de la connexion à Instagram, veuillez réessayer",
        "NEW_INBOX_SUGGESTION": "Ce compte Instagram était précédemment lié à une autre boîte de réception et a maintenant été migré ici. Tous les nouveaux messages apparaîtront ici. L'ancienne boîte de réception ne pourra plus envoyer ni recevoir de messages pour ce compte.",
        "DUPLICATE_INBOX_BANNER": "Ce compte Instagram a été migré vers la nouvelle boîte de réception du canal Instagram. Vous ne pourrez plus envoyer ni recevoir de messages Instagram depuis cette boîte de réception."
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again"
      },
      "TWITTER": {
        "HELP": "Pour ajouter votre profil Twitter en tant que canal, vous devez lier votre profil Twitter en cliquant sur 'Se connecter avec Twitter' ",
        "ERROR_MESSAGE": "Une erreur s'est produite lors de la connexion à Twitter, veuillez réessayer",
        "TWEETS": {
          "ENABLE": "Créer des conversations à partir de Tweets mentionnés"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal site Web",
        "DESC": "Créez un canal pour votre site Web et commencez à assister vos clients à l'aide de notre widget de site Web.",
        "LOADING_MESSAGE": "Création du canal de support du site Web",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar du canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL du Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Veuillez entrer une URL valide"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domaine du site Web",
          "PLACEHOLDER": "Entrez le domaine de votre site Web (ex : acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Titre de Bienvenue",
          "PLACEHOLDER": "Salut !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Slogan d'accueil",
          "PLACEHOLDER": "C'est simple de rentrer en contact avec nous. Demandez-nous quoi que ce soit ou partagez vos commentaires."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Message d'accueil du canal",
          "PLACEHOLDER": "Acme Inc répond en général en quelques heures."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Activer l'accueil du canal",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Activé",
          "DISABLED": "Désactivé"
        },
        "REPLY_TIME": {
          "TITLE": "Définir le temps de réponse",
          "IN_A_FEW_MINUTES": "En quelques minutes",
          "IN_A_FEW_HOURS": "En quelques heures",
          "IN_A_DAY": "En une journée",
          "HELP_TEXT": "Ce temps de réponse sera affichée sur le widget de chat en direct"
        },
        "WIDGET_COLOR": {
          "LABEL": "Couleur du Widget",
          "PLACEHOLDER": "Mettre à jour la couleur utilisée dans le widget"
        },
        "SUBMIT_BUTTON": "Créer une boîte de réception",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu créer un canal web, veuillez réessayer"
        }
      },
      "TWILIO": {
        "TITLE": "Chaîne Twilio SMS/WhatsApp",
        "DESC": "Intégrez Twilio et commencez à soutenir vos clients par SMS ou WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID du compte",
          "PLACEHOLDER": "Veuillez entrer le SID de votre compte Twilio",
          "ERROR": "Ce champ est requis"
        },
        "API_KEY": {
          "USE_API_KEY": "Utiliser l'authentification par clé API",
          "LABEL": "SID de la clé API",
          "PLACEHOLDER": "Veuillez entrer votre clé API SID",
          "ERROR": "Ce champ est requis"
        },
        "API_KEY_SECRET": {
          "LABEL": "Secret de la clé API",
          "PLACEHOLDER": "Veuillez entrer le secret de votre clé API",
          "ERROR": "Ce champ est requis"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID du service de messagerie",
          "PLACEHOLDER": "Veuillez entrer votre SID du service de messagerie Twilio",
          "ERROR": "Ce champ est requis",
          "USE_MESSAGING_SERVICE": "Utilisez un service de messagerie Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Type de canal",
          "ERROR": "Veuillez sélectionner votre type de canal"
        },
        "AUTH_TOKEN": {
          "LABEL": "Jeton d'authentification",
          "PLACEHOLDER": "Veuillez entrer votre jeton d'authentification Twilio",
          "ERROR": "Ce champ est requis"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nom de la boîte de réception",
          "PLACEHOLDER": "Veuillez entrer un nom de boîte de réception",
          "ERROR": "Ce champ est requis"
        },
        "PHONE_NUMBER": {
          "LABEL": "Numéro de téléphone",
          "PLACEHOLDER": "Veuillez entrer le numéro de téléphone à partir duquel le message sera envoyé.",
          "ERROR": "Veuillez fournir un numéro de téléphone valide qui commence par un signe `+` et ne contient aucun espace."
        },
        "API_CALLBACK": {
          "TITLE": "URL de rappel (callback)",
          "SUBTITLE": "Vous devez configurer l'URL de rappel (callback) du message dans Twilio avec l'URL mentionnée ici."
        },
        "SUBMIT_BUTTON": "Créer le canal Twilio",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu authentifier les identifiants Twilio, veuillez réessayer"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Commencez à soutenir vos clients par SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bande passante"
        },
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID du compte client",
            "PLACEHOLDER": "Veuillez entrer votre ID de compte de bande passante",
            "ERROR": "Ce champ est requis"
          },
          "API_KEY": {
            "LABEL": "Clé de l'API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Ce champ est requis"
          },
          "API_SECRET": {
            "LABEL": "Secret API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Ce champ est requis"
          },
          "APPLICATION_ID": {
            "LABEL": "ID de l'application",
            "PLACEHOLDER": "Veuillez entrer votre ID d'application de bande passante",
            "ERROR": "Ce champ est requis"
          },
          "INBOX_NAME": {
            "LABEL": "Nom de la boîte de réception",
            "PLACEHOLDER": "Veuillez entrer un nom de boîte de réception",
            "ERROR": "Ce champ est requis"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numéro de téléphone",
            "PLACEHOLDER": "Veuillez entrer le numéro de téléphone à partir duquel le message sera envoyé.",
            "ERROR": "Veuillez fournir un numéro de téléphone valide qui commence par un signe `+` et ne contient aucun espace."
          },
          "SUBMIT_BUTTON": "Créer un canal de bande passante",
          "API": {
            "ERROR_MESSAGE": "Nous n'avons pas pu authentifier les identifiants de bande passante, veuillez réessayer"
          },
          "API_CALLBACK": {
            "TITLE": "URL de rappel (callback)",
            "SUBTITLE": "Vous devez configurer l'URL de rappel du message en bande passante avec l'URL mentionnée ici."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "Chaîne WhatsApp",
        "DESC": "Commencez à soutenir vos clients via WhatsApp.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "Cloud WhatsApp",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "Fenêtre de dialogue 360"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Nom de la boîte de réception",
          "PLACEHOLDER": "Veuillez entrer un nom de boîte de réception",
          "ERROR": "Ce champ est requis"
        },
        "PHONE_NUMBER": {
          "LABEL": "Numéro de téléphone",
          "PLACEHOLDER": "Veuillez entrer le numéro de téléphone à partir duquel le message sera envoyé.",
          "ERROR": "Veuillez fournir un numéro de téléphone valide qui commence par un signe `+` et ne contient aucun espace."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "ID du numéro de téléphone",
          "PLACEHOLDER": "Veuillez entrer l'ID du numéro de téléphone obtenu à partir du tableau de bord du développeur Facebook.",
          "ERROR": "Veuillez saisir une adresse de courriel valide."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "Identifiant du compte professionnel",
          "PLACEHOLDER": "Veuillez entrer l'ID du compte professionnel obtenu depuis le tableau de bord des développeurs Facebook.",
          "ERROR": "Veuillez saisir une adresse de courriel valide."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Jeton de vérification du Webhook",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "Veuillez saisir une adresse de courriel valide."
        },
        "API_KEY": {
          "LABEL": "Clé de l'API",
          "SUBTITLE": "Configurer la clé API WhatsApp.",
          "PLACEHOLDER": "Clé de l'API",
          "ERROR": "Veuillez saisir une adresse de courriel valide."
        },
        "API_CALLBACK": {
          "TITLE": "URL de rappel (callback)",
          "SUBTITLE": "Vous devez configurer l'URL du webhook et le jeton de vérification du portail Facebook Developer avec les valeurs indiquées ci-dessous.",
          "WEBHOOK_URL": "URL du Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Jeton de vérification du Webhook"
        },
        "SUBMIT_BUTTON": "Créer le canal WhatsApp",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal WhatsApp"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Numéro de téléphone",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "SID du compte",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Jeton d'authentification",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "SID de la clé API",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "Secret de la clé API",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal API",
        "DESC": "Intégrez le canal API et commencez à aider vos clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL du Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "URL du Webhook"
        },
        "SUBMIT_BUTTON": "Créer un canal API",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canal Courriel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "EMAIL": {
          "LABEL": "Courriel",
          "SUBTITLE": "Adresse de courriel où vos clients vous envoient des demandes d'assistance",
          "PLACEHOLDER": "Courriel"
        },
        "SUBMIT_BUTTON": "Créer le canal Courriel",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal courriel"
        },
        "FINISH_MESSAGE": "Commencez à transférer vos courriels à l'adresse suivante.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Cliquez ici",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LINE",
        "DESC": "Intégrez le canal LINE et commencez à assister vos clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID du canal LINE",
          "PLACEHOLDER": "ID du canal LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secret du canal LINE",
          "PLACEHOLDER": "Secret du canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Jeton de canal LINE",
          "PLACEHOLDER": "Jeton de canal LINE"
        },
        "SUBMIT_BUTTON": "Créer le canal LINE",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL de rappel (callback)",
          "SUBTITLE": "Vous devez configurer l'URL du webhook dans l'application LINE avec l'URL mentionnée ici."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal Telegram",
        "DESC": "Intégrez le canal Telegram et commencez à assister vos clients.",
        "BOT_TOKEN": {
          "LABEL": "Jeton du robot",
          "SUBTITLE": "Configurez le jeton de bot que vous avez obtenu de Telegram BotFather.",
          "PLACEHOLDER": "Jeton du robot"
        },
        "SUBMIT_BUTTON": "Créer un canal Telegram",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal Telegram"
        }
      },
      "AUTH": {
        "TITLE": "Choisir un canal",
        "DESC": "Chatwoot supports live-chat widgets, Facebook Messenger, Twitter profiles, WhatsApp, Emails, etc., as channels. If you want to build a custom channel, you can create it using the API channel. To get started, choose one of the channels below.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Site internet",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "Appel WhatsApp",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "Courriel",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Agents",
        "DESC": "Ici vous pouvez ajouter des agents pour gérer votre boîte de réception nouvellement créée. Seuls ces agents sélectionnés auront accès à votre boîte de réception. Les agents qui ne font pas partie de cette boîte de réception ne seront pas en mesure de voir ou de répondre aux messages de cette boîte de réception lorsqu'ils se connectent. <br> <b>PS :</b> En tant qu'administrateur, si vous avez besoin d'accéder à toutes les boîtes de réception, vous devriez vous ajouter en tant qu'agent à toutes les boîtes de réception que vous créez.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Sélectionner les agents de la boîte de réception"
      },
      "DETAILS": {
        "TITLE": "Détails de la boîte de réception",
        "DESC": "Dans le menu déroulant ci-dessous, sélectionnez la page Facebook que vous voulez connecter à Chatwoot. Vous pouvez également donner un nom personnalisé à votre boîte de réception pour une meilleure identification."
      },
      "FINISH": {
        "TITLE": "Mission accomplie !",
        "DESC": "Vous avez terminé avec succès l’intégration de votre page Facebook avec Chatwoot. La prochaine fois qu’un client enverra un message à votre page, la conversation apparaîtra automatiquement dans votre boîte de réception.<br>Nous fournissons également un script de widget que vous pouvez facilement ajouter à votre site Web. Une fois que cela est configuré sur votre site web, les clients peuvent vous envoyer des messages directement depuis votre site Web sans l'aide d'un outil externe et la conversation apparaîtra ici, sur Chatwoot.<br>Cool, hein ? Eh bien, nous essayons de l'être :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Sélectionnez votre fournisseur de messagerie",
        "DESCRIPTION": "Sélectionnez un fournisseur de messagerie dans la liste ci-dessous. Si vous ne voyez pas votre fournisseur de messagerie dans la liste, vous pouvez sélectionner l'autre fournisseur et fournir les identifiants IMAP et SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Cliquez sur le bouton Connexion avec Microsoft pour commencer. Vous allez rediriger vers la page de connexion par courriel. Une fois que vous avez accepté les autorisations demandées, vous serez redirigé vers l'étape de création de la boîte de réception.",
        "EMAIL_PLACEHOLDER": "Entrez votre adresse e-mail",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Une erreur s'est produite lors de la connexion à Microsoft, veuillez réessayer"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Entrez votre adresse e-mail",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authentification avec Facebook ...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Une erreur s'est produite, veuillez rafraîchir la page ...",
      "ERROR_FB_UNAUTHORIZED": "Vous n'êtes pas autorisé à effectuer cette action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Veuillez vous assurer que vous avez un contrôle total sur la page Facebook. Vous pouvez en savoir plus sur les rôles Facebook <a href=\" https://www.facebook.com/help/187316341316631\">ici</a>.",
      "CREATING_CHANNEL": "Création de votre boîte de réception ...",
      "TITLE": "Configurer les détails de la boîte de réception",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Ajouter des agents",
      "ADD_AGENTS": "Ajout d'agents à votre boîte de réception ..."
    },
    "FINISH": {
      "TITLE": "Votre boîte de réception est prête !",
      "MESSAGE": "Vous pouvez maintenant vous impliquer auprès de vos clients par le biais de votre nouveau canal. Bonne assistance",
      "BUTTON_TEXT": "Emmenez-moi là",
      "MORE_SETTINGS": "Plus de paramètres",
      "WEBSITE_SUCCESS": "Vous avez terminé avec succès la création d'un canal Web. Copiez le code affiché ci-dessous et collez-le sur votre site web. La prochaine fois qu'un client utilisera le chat en direct, la conversation apparaîtra automatiquement dans votre boîte de réception.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Réautoriser",
    "VIEW": "Voir",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Paramètres de boîte de réception mis à jour avec succès",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Affectation automatique mise à jour avec succès",
        "ERROR_MESSAGE": "Nous n'avons pas pu mettre à jour les paramètres de la boîte de réception. Veuillez réessayer plus tard."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Nom de l'expéditeur",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "Par exemple:",
        "FRIENDLY": {
          "TITLE": "Amical",
          "FROM": "de",
          "SUBTITLE": "Ajoute le nom de l'agent qui a envoyé la réponse dans le nom de l'expéditeur pour la rendre plus conviviale."
        },
        "PROFESSIONAL": {
          "TITLE": "Professionnel",
          "SUBTITLE": "Utilisez uniquement le nom d'entreprise configuré comme nom d'expéditeur dans l'en-tête du courriel."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configurez votre nom d'entreprise",
          "PLACEHOLDER": "Entrez le nom de votre entreprise",
          "SAVE_BUTTON_TEXT": "Enregistrer"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Activer"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Supprimer",
      "AVATAR_DELETE_BUTTON_TEXT": "Supprimer l'avatar",
      "CONFIRM": {
        "TITLE": "Confirmer la suppression",
        "MESSAGE": "Êtes-vous sûr de vouloir supprimer ",
        "PLACE_HOLDER": "Veuillez taper {inboxName} pour confirmer",
        "YES": "Oui, supprimer ",
        "NO": "Non, Conserver "
      },
      "API": {
        "SUCCESS_MESSAGE": "Boîte de réception supprimée avec succès",
        "ERROR_MESSAGE": "Impossible de supprimer la boîte de réception. Veuillez réessayer plus tard.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar de la boîte de réception supprimé avec succès",
        "AVATAR_ERROR_MESSAGE": "Impossible de supprimer l'avatar de la boîte de réception. Veuillez réessayer plus tard."
      }
    },
    "TABS": {
      "SETTINGS": "Paramètres",
      "COLLABORATORS": "Collaborateurs",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campagnes",
      "PRE_CHAT_FORM": "Formulaire avant chat",
      "BUSINESS_HOURS": "Heures de bureau",
      "WIDGET_BUILDER": "Constructeur de Widget",
      "BOT_CONFIGURATION": "Configuration du bot",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "En direct"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Paramètres",
    "FEATURES": {
      "LABEL": "Fonctionnalités",
      "DISPLAY_FILE_PICKER": "Afficher le sélecteur de fichiers sur le widget",
      "DISPLAY_EMOJI_PICKER": "Afficher le sélecteur d'émoticônes sur le widget",
      "ALLOW_END_CONVERSATION": "Permettre aux utilisateurs de terminer la conversation depuis le widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Utiliser le nom de la boîte de réception et l'avatar pour le bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script du Widget Web",
      "MESSENGER_SUB_HEAD": "Placez ce code avant la fermeture de votre balise body",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Agents",
      "INBOX_AGENTS_SUB_TEXT": "Ajouter ou supprimer des agents de cette boîte de réception",
      "AGENT_ASSIGNMENT": "Konversationsauftrag",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Aktualisieren Sie die Konversationszuweisungseinstellungen",
      "UPDATE": "Mettre à jour",
      "ENABLE_EMAIL_COLLECT_BOX": "Activer la boîte de collecte des courriels",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Activer ou désactiver la boîte de collecte des courriels pour les nouvelles conversations",
      "AUTO_ASSIGNMENT": "Activer l'assignation automatique",
      "SENDER_NAME_SECTION": "Activer le nom de l'agent dans l'e-mail",
      "SENDER_NAME_SECTION_TEXT": "Activer/Désactiver l'affichage du nom de l'agent dans l'e-mail, si désactivé, il affichera le nom de l'entreprise",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Activer la continuité de la conversation par e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Les conversations se poursuivront par courrier électronique si l'adresse e-mail du contact est disponible.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Paramètres de boîtes de réception",
      "INBOX_UPDATE_SUB_TEXT": "Mettre à jour les paramètres de votre boîte de réception",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Activer ou désactiver l'affectation automatique de nouvelles conversations aux agents ajoutés à cette boîte de réception.",
      "HMAC_VERIFICATION": "Validation de l'identité de l'utilisateur",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_LINK_TO_DOCS": "Vous pouvez en lire plus ici.",
      "HMAC_MANDATORY_VERIFICATION": "Forcer la validation de l'identité de l'utilisateur",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "INBOX_IDENTIFIER": "Identificateur de la boîte de réception",
      "INBOX_IDENTIFIER_SUB_TEXT": "Utilisez le jeton `inbox_identifier` affiché ici pour authentifier vos clients API.",
      "FORWARD_EMAIL_TITLE": "Transférer par e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Commencez à transférer vos courriels à l'adresse suivante.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Autoriser les messages après résolution de la conversation",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Autoriser les utilisateurs à envoyer des messages même après la résolution de la conversation.",
      "WHATSAPP_SECTION_SUBHEADER": "Cette clé API est utilisée pour l'intégration avec les API WhatsApp.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "Clé de l'API",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Mettre à jour la clé API",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Entrez la nouvelle clé API ici",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Mettre à jour",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Connecter",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Jeton de vérification du Webhook",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Ce jeton est utilisé pour vérifier l'authenticité du point de terminaison du webhook.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Mettre à jour les paramètres du formulaire de pré-chat"
    },
    "HELP_CENTER": {
      "LABEL": "Centre d'aide",
      "PLACEHOLDER": "Sélectionnez le centre d'aide",
      "SELECT_PLACEHOLDER": "Sélectionnez le centre d'aide",
      "NONE": "Aucun",
      "REMOVE": "Supprimer le centre d'aide",
      "SUB_TEXT": "Attachez un centre d'aide avec la boîte de réception"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limite de l'affectation automatique",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Veuillez entrer une valeur supérieure à 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limiter le nombre maximum de conversations de cette boîte de réception qui peuvent être assignées automatiquement à un agent"
    },
    "ASSIGNMENT": {
      "TITLE": "Konversationsauftrag",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Actif",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Annuler",
      "CONFIRM_DELETE": "Supprimer",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Réautoriser",
      "SUBTITLE": "Votre connexion Facebook a expiré, veuillez reconnecter votre page Facebook pour continuer les services",
      "MESSAGE_SUCCESS": "Reconnexion réussie",
      "MESSAGE_ERROR": "Une erreur est survenue, veuillez réessayer"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Les formulaires précédant le chat vous permettent de saisir les informations de l'utilisateur avant qu'ils ne commencent à discuter avec vous.",
      "SET_FIELDS": "Champs du formulaire de pré-chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Champs",
        "LABEL": "Étiquettes",
        "PLACE_HOLDER": "Espace réservé",
        "KEY": "Clé",
        "TYPE": "Type",
        "REQUIRED": "Obligatoire"
      },
      "ENABLE": {
        "LABEL": "Activer le formulaire précédant le chat",
        "OPTIONS": {
          "ENABLED": "Oui",
          "DISABLED": "Non"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Message avant la discussion",
        "PLACEHOLDER": "Ce message serait visible pour les utilisateurs avec le formulaire"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Les visiteurs doivent indiquer leur nom et leur courriel avant de commencer le chat"
      }
    },
    "CSAT": {
      "TITLE": "Activer CSAT",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Message",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Langue",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Retour"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "contient",
          "DOES_NOT_CONTAINS": "ne contient pas"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Définissez votre disponibilité",
      "SUBTITLE": "Définissez votre disponibilité sur votre widget livechat",
      "WEEKLY_TITLE": "Définissez vos horaires de travail",
      "TIMEZONE_LABEL": "Sélectionnez le fuseau horaire",
      "UPDATE": "Mettre à jour les paramètres des heures de bureau",
      "TOGGLE_AVAILABILITY": "Activer la disponibilité aux heures de bureau pour cette boîte de réception",
      "UNAVAILABLE_MESSAGE_LABEL": "Message d'indisponibilité pour les visiteurs",
      "TOGGLE_HELP": "Activer la disponibilité professionnelle montrera les heures disponibles sur le widget chat en direct même si tous les agents sont hors ligne. En dehors des heures disponibles, les visiteurs peuvent être avertis avec un message et un formulaire de préconversation.",
      "DAY": {
        "DAY": "Jour",
        "AVAILABILITY": "Disponibilité",
        "HOURS": "Heures",
        "ENABLE": "Activer la disponibilité pour ce jour",
        "UNAVAILABLE": "Non disponible",
        "VALIDATION_ERROR": "L'heure de début doit être avant l'heure de fermeture.",
        "CHOOSE": "Sélectionner"
      },
      "ALL_DAY": "Toute la journée"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Définir vos détails IMAP",
      "NOTE_TEXT": "Pour activer le SMTP, veuillez configurer IMAP.",
      "UPDATE": "Modifier les paramètres IMAP",
      "TOGGLE_AVAILABILITY": "Activer la configuration IMAP pour cette boîte de réception",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Paramètres IMAP mis à jour avec succès",
        "ERROR_MESSAGE": "Impossible de mettre à jour les paramètres IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresse IP",
        "PLACE_HOLDER": "Adresse (ex: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Se connecter",
        "PLACE_HOLDER": "Se connecter"
      },
      "PASSWORD": {
        "LABEL": "Mot de passe",
        "PLACE_HOLDER": "Mot de passe"
      },
      "ENABLE_SSL": "Activer SSL",
      "AUTH_MECHANISM": "Identification"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Réautoriser votre compte MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Définissez vos détails SMTP",
      "UPDATE": "Mettre à jour les paramètres",
      "TOGGLE_AVAILABILITY": "Activer la configuration SMTP pour cette boîte de réception",
      "TOGGLE_HELP": "Activer SMTP aidera l'utilisateur à envoyer des e-mails",
      "EDIT": {
        "SUCCESS_MESSAGE": "Paramètres IMAP mis à jour avec succès",
        "ERROR_MESSAGE": "Impossible de mettre à jour les paramètres IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresse IP",
        "PLACE_HOLDER": "Adresse (ex: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Se connecter",
        "PLACE_HOLDER": "Se connecter"
      },
      "PASSWORD": {
        "LABEL": "Mot de passe",
        "PLACE_HOLDER": "Mot de passe"
      },
      "DOMAIN": {
        "LABEL": "Domaine",
        "PLACE_HOLDER": "Domaine"
      },
      "ENCRYPTION": "Chiffrement",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Ouvrir le mode de vérification SSL",
      "AUTH_MECHANISM": "Identification"
    },
    "NOTE": "Note : ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar du site web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar supprimé avec succès",
              "ERROR_MESSAGE": "Une erreur est survenue, veuillez réessayer"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nom du site web",
          "PLACE_HOLDER": "Entrez le nom de votre boîte de réception (ex: Acme Inc)",
          "ERROR": "Veuillez entrer un nom de site Web valide"
        },
        "WELCOME_HEADING": {
          "LABEL": "Titre de Bienvenue",
          "PLACE_HOLDER": "Salut!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Slogan d'accueil",
          "PLACE_HOLDER": "C'est simple de rentrer en contact avec nous. Demandez-nous quoi que ce soit ou partagez vos commentaires."
        },
        "REPLY_TIME": {
          "LABEL": "Temps de réponse",
          "IN_A_FEW_MINUTES": "En quelques minutes",
          "IN_A_FEW_HOURS": "En quelques heures",
          "IN_A_DAY": "En une journée"
        },
        "WIDGET_COLOR_LABEL": "Couleur du Widget",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Type:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Discutez avec nous",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Discutez avec nous"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Mettre à jour les paramètres du Widget",
          "API": {
            "SUCCESS_MESSAGE": "Les paramètres du widget ont été mis à jour",
            "ERROR_MESSAGE": "Impossible de modifier les paramètres du widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Prévisualiser",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Gauche",
          "RIGHT": "Droite"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Bulle élargie"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Par défaut",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Répond généralement en quelques minutes",
        "IN_A_FEW_HOURS": "Répond généralement en quelques heures",
        "IN_A_DAY": "Répond généralement dans la journée"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Démarrer la conversation",
        "CHAT_INPUT_PLACEHOLDER": "Tapez votre message"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Nous sommes en ligne",
          "OFFLINE": "Nous sommes absents pour le moment"
        },
        "USER_MESSAGE": "Salut",
        "AGENT_MESSAGE": "Bonjour"
      },
      "BRANDING_TEXT": "Propulsé par Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Autres fournisseurs",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Site internet",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "Courriel",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal API",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
